<template>
  <div class="pb-40 box grow scrollable">
    <div class="sticky">
      <el-row :gutter="20" class="">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <HeaderCard :title="$t('CMSProvider.title')" :col="12" :showAddButton="false"></HeaderCard>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="text-right">
              <el-row>
                <!-- Sauvegarde -->
                <el-col>
                    <el-button type="primary" size="small" @click="save()">Sauvegarder</el-button>
                    <el-button size="small" @click="back()">Annuler</el-button>

                    <el-button size="small" v-if="isEditionMode" class="ml-10" icon="el-icon-delete" @click="handleDeleteProduct"></el-button>
                </el-col>
              </el-row>
          </el-col>
        </el-row>
    </div>
    <div class="list box grow" style="height:80%;">
      <el-form ref="formProvider" :model="model" :rules="rules">
        <el-row :gutter="20">
          <!-- Colonne de gauche -->
           <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
             <el-card>
               <el-row class="mr-20" :gutter="20">
                 <!-- Nom -->
                  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                     <el-form-item :label="$t('CMSProvider.name')" prop="name">
                        <el-input v-model="model.name" @change="handleNameChanged"></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align:right">
                    <el-row justify="end">
                      <el-col>
                        <el-checkbox size="small" class="m-10" v-model="model.published" label="Publié" border @change="v=> handlePublishing(v)"></el-checkbox>
                      </el-col>
                      <el-col v-if="isEditionMode">
                          <span class="secondary-text fs-12">Date de création : {{_moment(model.createdDate, 'lll')}}</span>
                      </el-col>
                      <el-col v-if="isEditionMode">
                          <span class="secondary-text fs-12">Dernire mise à jour : {{_moment(model.updatedDate, 'lll')}}</span>
                      </el-col>
                      <el-col v-if="model.published">
                          <span class="secondary-text fs-12" v-if="!editPublishedDate">Publié le : <el-link type="primary" @click="handleEditPublishedDate(true)" class="secondary-text fs-12">{{_moment(model.publishedDate, 'lll')}} <i class="el-icon-edit"></i></el-link></span>
                          <el-date-picker
                            ref="publishDateComponent"
                            v-else
                            size="mini"
                            v-model="model.publishedDate"
                            style="width:170px"
                            type="datetime"
                            @change="handlePublishedDateChange"
                            placeholder="Selectionnez date et horaire">
                          </el-date-picker>
                      </el-col>
                    </el-row>
                  </el-col>
                  <!-- Slug -->
                   <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <div v-if="!indChangeSlug">
                       <span class="fs-14 m-10 pb-20">
                         Slug URL:
                       </span>
                       <span class="fs-14 secondary-text">
                         /{{model.slug}}
                       </span>
                       <el-button v-if="model.name != null && model.name != ''" type="text" icon="el-icon-edit" class="ml-10" @click="handleChangeSlug"/>
                     </div>
                      <el-form-item :label="$t('CMSProduct.slug')" prop="slug" v-else>
                         <el-input v-model="model.slug"></el-input>
                       </el-form-item>
                   </el-col>
                 <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                   <el-form-item>
                     <el-table
                       empty-text="Aucune producteur lié"
                       :data="model.customers"
                       stripe
                       :cell-style="{padding:'2px'}"
                       style="width: 100%">
                       <el-table-column label="Producteur liés">
                        <template slot-scope="scope" >
                          <span>{{getCustomerName(scope.row)}}</span>
                        </template>
                       </el-table-column>
                       <el-table-column align="right">
                         <template slot="header" slot-scope="scope">
                            <el-button size="small" @click="openProviderModal">Lier un producteur <i class="el-icon-circle-plus-outline"></i></el-button>
                          </template>
                         <template slot-scope="scope" >
                           <el-button
                           size="mini"
                           type="danger"
             							 circle
                           @click="revomeProvider(scope.$index)"><i class="mdi mdi-delete fs-15"></i></el-button>
                         </template>
                       </el-table-column>
                     </el-table>
                   </el-form-item>
                 </el-col>

                  <!-- Disponible -->
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                     <el-form-item :label="$t('CMSProvider.origin_availability')">
                       <el-select
                           v-model="model.types"
                           multiple
                           value-key="id"
                           filterable>
                           <el-option
                             v-for="item in providerTypes"
                             :key="item.id"
                             :label="item.name[lang]"
                             :value="item">
                           </el-option>
                         </el-select>
                      </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl=24>
                    <el-form-item>
                      <span>{{$t('CMSProvider.origin')}}</span>
                      <OriginsTable :origins="model.origins" @remove="removeOrigin" @add="v=>addRegionToOriginsModel(v.country, v.region, v.city)"></OriginsTable>
                    </el-form-item>
                  </el-col>
                  <!-- logo -->
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                    <el-form-item>
                      {{$t('CMSProvider.logo_label')}}
                      <div class="text-center" v-if="model.logo==null && providerGaleryType!=null">
                        <ImageUploadWidget  :typeId="providerGaleryType.id" @select="v => handleGalerySelection(v, 'logo')"></ImageUploadWidget>
                      </div>
                      <div class="item card-base card-alt text-center" v-if="model.logo!=null">
                        <img v-lazy="model.logo.thumbnailLink" alt="card image">
                      </div>
                      <span v-if="model.logo!=null"><el-button type="text" @click="removeLogo">{{$t('CMSProvider.logo.remove')}}</el-button></span>

                    </el-form-item>
                  </el-col>
                  <!-- Image principale -->
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">

                    <el-form-item>
                      {{$t('CMSProvider.main_image')}}
                      <div class="text-center" v-if="model.main==null && providerGaleryType!=null">
                        <ImageUploadWidget :typeId="providerGaleryType.id" @select="v => handleGalerySelection(v, 'main')"></ImageUploadWidget>
                      </div>
                      <div class="main card-base card-alt" v-if="model.main!=null">
                        <img v-lazy="model.main.link" alt="card image">
                      </div>
                      <span v-if="model.main!=null"><el-button type="text" @click="removeMain">{{$t('CMSProvider.main.remove')}}</el-button></span>

                    </el-form-item>
                  </el-col>
                  <!-- Site web -->
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <el-form-item label="Site web">
                      <el-input placeholder="Saisir une adresse web" v-model="model.webSite">
                        <template slot="prepend">Http://</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <!-- Summary -->
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <el-collapse v-model="contentTabs" >
                    <el-collapse-item title="Résumé" name="1">
                        <el-form-item >
                          <el-tabs v-model="languageTabs" type="border-card">
                            <el-tab-pane v-for="l in cms_languages" :key="l.id" :label="l.name" :name="l.code">
                              <quill-editor v-model="model.summary[l.code]" style="margin-top:40px;border:1px solid #EBEEF5;min-height:200px;"
                                ref="noteEditor"
                                :options="editorOptions">
                              </quill-editor>
                            </el-tab-pane>
                          </el-tabs>
                        </el-form-item>

                    </el-collapse-item>
                    <el-collapse-item title="Contenu principal" name="2">
                      <!-- Contenu -->
                        <el-form-item >
                          <el-tabs v-model="languageTabs" type="border-card">
                            <el-tab-pane v-for="l in cms_languages" :key="l.id" :label="l.name" :name="l.code">
                              <quill-editor v-model="model.content[l.code]" style="margin-top:40px;border:1px solid #EBEEF5;min-height:200px;"
                                ref="noteEditor"
                                :options="editorOptions">
                              </quill-editor>
                            </el-tab-pane>
                          </el-tabs>
                        </el-form-item>

                    </el-collapse-item>
                    <el-collapse-item title="Article(s) associé(s)" name="3">
                      <!-- Article relié -->
                        <SelectBlogs
                          :blogs="model.blogs"
                          @selected="handleBlogsSelected"/>
                    </el-collapse-item>
                  </el-collapse>
                  </el-col>

                  <!-- Gallerie -->
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">

                    <el-form-item>
                      {{$t('CMSProvider.galeries')}}
                      <div class="text-center" v-if="providerGaleryType!=null">
                        <ImageUploadWidget  :enabledMutlipleImageSelection="true" :typeId="providerGaleryType.id" @select="v => handleGalerySelection(v, 'galleries')"></ImageUploadWidget>
                      </div>
                       <GaleryMasonry :showCode="false" :showDescription="false" :showInGalery="false" :selection="false" :edition="false" :multiple="false" :images="model.galeries" class="m-20" @delete="handleRemoveGalleryItem" @show="show"></GaleryMasonry>
                     </el-form-item>
                  </el-col>
                </el-row>
              </el-card>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <SearchCustomerDialog :title="searchProviderTitle" :visible="addProviderDialogVisible" @close="closeProviderModal" @select="addProvider"></SearchCustomerDialog>
    <img-viewer  ref="viewer" :images="model.galeries"/>
    <GalleryDialog :dialogVisible="galleryDialogVisible" :selection="true" :multiple="enabledMutlipleImageSelection" @close="closeGaleryialog" @select="handleGalerySelection"></GalleryDialog>
  </div>
</template>
<script>
import moment from 'moment'
import HeaderCard from '@/components/header-card'
import GalleryDialog from './components/gallery-dialog'
import GaleryMasonry from './components/galery-masonry'
import imageUtil from '@/utils/image-util.js'
import customerUtil from '@/utils/customer-util.js'
import { mapActions, mapState, mapGetters } from 'vuex';
import cmsAPI from '@/services/API/cmsAPI'
import customerAPI from '@/services/API/customer'
import ImgViewer from "@/components/ImgViewer";
import ImageUploadWidget from "./components/image-upload-widget"
import SearchCustomerDialog from "@/components/customer/search-customer-dialog"
import OriginsTable from './components/origin-table'
import SelectBlogs from './components/select-cms-blogs'

export default {
	name: 'Provider-Editor',
	data() {
		return {
      editPublishedDate : false,
      oldPublishedDate: null,
      contentTabs : ["2"],
      galleryDialogVisible : false,
      enabledMutlipleImageSelection : false,
      providerloading : false,
      indChangeSlug: false,
      model : {
        published: false,
        publishedDate: null,
        id : null,
        customers : [],
        name : null,
        slug: null,
        content : {fr : '', en:''},
        summary : {fr : '', en:''},
        logo : null,
        main : null,
        galeries : [],
        origins : [],
        lockVersion : null,
        types : [],
        regions : [],
        webSite : null,
        blogs: [],
      },
      galeryTypes : [],
      addProviderDialogVisible : false,
      providerTypes : [],
      languageTabs : "fr",
      loadingLogo : false,
      editorOptions: {
        placeholder:"Saisir du contenu...",
        modules: {
					toolbar: [
						['bold', 'italic', 'underline', 'strike', 'link']
					]
				}
			},
      rules : {
        name : [
          { required: true, message: 'Veuillez saisir un nom', trigger: 'blur' }
        ]
      }
		}
	},
  components : {
    HeaderCard,
    GalleryDialog,
    GaleryMasonry,
    ImgViewer,
    ImageUploadWidget,
    SearchCustomerDialog,
    OriginsTable,
    SelectBlogs,
  },
  computed : {
    searchProviderTitle () {
      return this.$i18n.t('CMSProvider.linkProviderTitle');
    },
    providerGaleryType(){
      return _.find(this.galeryTypes, t=>{return t.code=='PROVIDER'})
    },
		providerId(){
			return this.$route.params.providerId!=null ? parseInt(this.$route.params.providerId) : null;
		},
    cms_languages(){
      return _.filter(this.languages, l=>{return l.cms_language});
    },
    lang(){
      return this.$i18n.locale
    },
    isEditionMode(){
      return this.providerId!=null;
    },
    ...mapState('controlData',['languages', 'countries']),
  },
  methods : {
    handleBlogsSelected (blogs) {
      this.model.blogs = blogs;
    },
    back(){
      this.$router.go(-1);
    },
    handlePublishedDateChange () {
      this.handleEditPublishedDate(false);
    },
    handleEditPublishedDate (editInd) {
      this.editPublishedDate = editInd;
      if (editInd) {
        if (this.model.publishedDate == null) {
          this.model.publishedDate = new moment().format();
        }
        this.oldPublishedDate = this.model.publishedDate;
        this.$nextTick(() => this.$refs['publishDateComponent'].focus());
      }
    },
    handlePublishing (published){
      if(this.isEditionMode){
        this.providerloading = true;
        this.model.published = published;

        if (published) {
          this.model.publishedDate = new moment().format();
        }
        // return this.save();
      } else {
        this.model.published = published;
        this.model.publishedDate = new moment().format();
      }


    },
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);

		},
    handleDeleteProduct () {
      this.$confirm('Êtes vous sûr de vouloir supprimer le producteur?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
        })
        .then(() => cmsAPI.deleteProvider(this.model.id))
        .then(() => this.$message.success("Le producteur a été supprimé avec succès!"))
        // .then(() => this.invalidate())
        .then(() => this.back())
        .catch(err => {
          if(err=="cancel"){
            this.$message('Suppression annulée!');
          }else{
            console.log(err);
            this.$message.error('Une erreur est survenue. Veuillez réessayer plus tard');
          }
        })
    },
    handleChangeSlug () {
      this.indChangeSlug = true;
    },
    handleNameChanged (value){
      this.model.slug = _.kebabCase(value);
    },
    getCustomerName(customer){
      // console.log(customer)
      return customerUtil.customerName(customer.name, customer.usualName);
    },
    show(index){
      this.$refs.viewer.show(
        this.model.galeries,
        index
      );
    },
    addProvider(provider){
      this.model.customers.push(provider);
    },
    openProviderModal(){
      this.addProviderDialogVisible = true;
    },
    closeProviderModal(){
      this.addProviderDialogVisible = false;
    },
    addRegionToOriginsModel(country, region, city){
      this.model.origins.push({country, region, city});
    },
    revomeProvider(index){
      this.model.customers.splice(index,1);
    },
    removeOrigin(index){
      this.model.origins.splice(index,1);
    },
    validateProviderForm(){
      return this.$refs['formProvider'].validate()
        .then(valid=>{
          if(valid) return true;
          else return Promise.reject(false);
        })
    },
    save(){
      this.validateProviderForm()
        .then(()=>{
          let postData = {};
          postData.customers = [];
          _.forEach(this.model.customers, c=>{postData.customers.push({id:c.id})});
          postData.name = this.model.name;
          postData.logo = this.model.logo!=null ? {id:this.model.logo.id } : undefined;
          postData.webSite = this.model.webSite;
          postData.images = [];
          if(this.model.galeries!= null && this.model.galeries.length>0){
            _.forEach(this.model.galeries, g=>{postData.images.push({id:g.id})});
          }

          postData.mainImage = this.model.main != null ? {id:this.model.main.id} : undefined;

          postData.products = [];
          postData.types = [];
          _.forEach(this.model.types, t=>{postData.types.push({id:t.id})})
          postData.attributes = []; // no attributes for providers (for the moment)
          postData.origins = this.model.origins;
          postData.content = this.model.content;
          postData.summary = this.model.summary;
          postData.slug = this.model.slug;
          postData.published = this.model.published;
          postData.publishedDate = this.model.publishedDate;

          postData.blogs = _.map(this.model.blogs, b => ({ id: b.id }));

          if(!this.isEditionMode){
            return cmsAPI.saveProvider(postData)
              .then(providerCreated=>{
                this.$message.success(this.$i18n.t('provider.provider_created'));
                this.model.lockVersion +=1;
                this.$router.push('/settings/CMS/providers');
              }).catch(err=>{
                console.log(err);
                this.$message.error(this.$i18n.t('provider.provider_creation_failed'));
              })
          }else{
            postData.lockVersion = this.model.lockVersion;
            return cmsAPI.updateProvider(this.model.id, postData)
              .then(providerCreated=>{
                this.$message.success(this.$i18n.t('provider.provider_updated'));
                this.$router.push('/settings/CMS/providers');
              }).catch(err=>{
                console.log(err);
                this.$message.error(this.$i18n.t('provider.provider_update_failed'));
              })
          }
        })

    },
    handleRemoveGalleryItem(id){
      let index = _.findIndex(this.model.galeries, g=>{return g.id==id});
      this.model.galeries.splice(index,1);
    },
    removeLogo(){
      this.model.logo=null;
    },
    removeMain(){
      this.model.main=null;
    },
    handleGalerySelection(asset, usedFor){
      if(usedFor=='logo'){
        this.model.logo = asset[0];
      }else if(usedFor=='main'){
        this.model.main = asset[0];
      }else if(usedFor=='galleries'){
        if (this.model.galeries == null) {
          this.model.galeries = [];
        }
        this.model.galeries.push(...asset);
      }
    },
    closeGaleryialog(){
      this.galleryDialogVisible=false;
    },
    initContent(){
      _.forEach(this.cms_languages, l=>{
        this.model.content[l.code] = '';
      })
    },
    getProvider(providerId){
      return cmsAPI.getCMSProvider(this.providerId)
    },
    setModel(provider){
      this.model.id= provider.id;
      this.model.published = provider.published;
      this.model.publishedDate = provider.publishedDate != null ? provider.publishedDate : new moment().format();
      this.model.name = provider.name;
      this.model.webSite = provider.webSite;
      _.forEach(provider.customers, c=>{
        this.model.customers.push({id:c.id, name:c.name, usualName:c.usualName});
      })
      this.model.origins = provider.origins;
      this.model.logo = provider.logo;
      this.model.slug = provider.slug;
      this.model.main = provider.mainImage;
      this.model.content = provider.content;
      if(provider.summary){
        this.model.summary = provider.summary;
      }
      this.model.galeries = provider.images;
      this.model.types = provider.types;
      this.model.lockVersion = provider.lockVersion;
      this.model.createdDate = provider.createdDate;
      this.model.updatedDate = provider.updatedDate;

      this.model.blogs = provider.blogs;
    },
    fetchCMSGalleryTypes(){
      return cmsAPI.fetchCMSGalleryTypes()
        .then(types=>{
          this.galeryTypes.push(...types);
        })
    },
    fetchProviderTypes(){
      return cmsAPI.fetchProviderTypes()
        .then(providerTypes=>{
          this.providerTypes = providerTypes;
        })
    },
    ...mapActions('controlData',['fetchLanguages', 'fetchCountries']),
  },
  mounted(){
    if(this.isEditionMode){
      return this.getProvider(this.providerId)
        .then(provider=>{
          this.setModel(provider);
        })
        .catch((err) => {
          this.back();
          this.$message.error('Une erreur est survenue. Veuillez réessayer plus tard');
        })
    }else{
      this.initContent();
    }
  },
  created(){
    return Promise.all([
      this.fetchLanguages(),
      this.fetchProviderTypes(),
      this.fetchCMSGalleryTypes(),
    ])

  }

}
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/_variables';

.add-galery{
  cursor:pointer;
}

.sticky {
  position: -webkit-sticky;
  position: sticky;
  top:0px;
  z-index:1000;
  background-color:#f3f7fa;
}

.main{
  padding: 20px;
  //margin: 20px 0;
  margin-bottom: 20px;
  //border-radius: 5px;
  // opacity: .85;
  transition: all .25s;

  /* masonry */
  //display: inline-block;
  box-sizing: border-box;
  box-shadow: 0px 0px 0px 1px $text-color-accent;
  width:100%;

  line-height:normal;

  img {
    width: 100%;
    max-width: 100%;
  }
}

.item {
  padding: 20px;
  //margin: 20px 0;
  margin-bottom: 20px;
  //border-radius: 5px;
  // opacity: .85;
  transition: all .25s;

  /* masonry */
  //display: inline-block;
  box-sizing: border-box;
  box-shadow: 0px 0px 0px 1px $text-color-accent;
  width: 200px;
  line-height:normal;
  img {
    // width: 100%;
    // max-width: 100%;
  }

}

</style>
